<template>
  <div class="outlet page">
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet" @onChangeProductType="onChangeProductType" />
    <UiTable :timeType="filterType" :reportData="report" :colsData="cols" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiTable from '@/components/UiTable'
import reportType from '@/config/reportType'
export default {
  name: 'ProductPage',
  components: {
    UiFilterbar,
    UiTable
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      query: {
        page: 1,
        limit: 100,
        mode: 'DATE',
        outletIds: null,
        timeZone: timeZone,
        reportingMode: 'in_store'
      },
      filterType: 'DATE',
      type: 'products'
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      cols: 'report/getColsData'
    })
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore'
    }),
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses, productTypes) {
      this.query.states = []
      this.query.statuses = []
      states = []
      statuses = []
      this.query.productTypes = productTypes
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.products,
        query: {
          ...this.query,
          ...day,
          states,
          statuses,
          productTypes
        }
      })
    },
    onDefaultFilter (day, type) {
      this.day = day
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.products,
        query: {
          ...this.query,
          ...day
        }
      })
    }
  },
  onChangeProductType (reportingMode, outletIds, registerIds, day, type, productTypes) {
    this.query.outletIds = outletIds
    this.query.registerIds = registerIds
    this.query.reportingMode = reportingMode
    this.filterType = type
    this.query.mode = type
    this.getReport({
      type: reportType.products,
      query: {
        ...this.query,
        ...day,
        productTypes
      }
    })
  },
  prepareDataToViewOnTable () {
    const list = {
      title: {},
      items: {}
    }

    this.report.forEach(item => {
      list.title[item.sku] = item.name

      if (list.items[item.sku] === undefined) {
        list.items[item.sku] = {}
      }

      list.items[item.sku][item.createdAt] = item.totalPrice
    })

    return list
  },
  prepareColsToViewOnTable () {
    const cols = {}

    this.report.forEach(item => {
      cols[item.createdAt] = true
    })

    return cols
  }
}
</script>

<style lang="scss" scoped></style>
